import { render, staticRenderFns } from "./flujoGeneral.vue?vue&type=template&id=3458ccc2&scoped=true"
import script from "./flujoGeneral.vue?vue&type=script&lang=js"
export * from "./flujoGeneral.vue?vue&type=script&lang=js"
import style0 from "./flujoGeneral.vue?vue&type=style&index=0&id=3458ccc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3458ccc2",
  null
  
)

export default component.exports